
	import { defineComponent, ref, computed, onBeforeMount, toRefs, watchEffect } from 'vue';
	import { useRoute } from 'vue-router';
	import { getLyraEndpoints, getLyraEndpoint } from '@/core/modules/lyra/services';

	export default defineComponent ({
		props: {
			datum: {
				type: Object,
				required: true,
			},
			carouselIndex: {
				type: Number,
				default: 0
			}
		},
		setup(props) {
			/**
			 * Endpoint
			 */
			const route = useRoute();
			const endpointId = computed((): any => {
				return route.params.endpointId;
			})
			const sectionId = computed((): any => {
				return route.params.sectionId;
			})
			const endpointObj = computed((): any => {
				const sections = getLyraEndpoints('sections');
				const currentSection: any = sections.find((_: any) => _.endpointId === sectionId.value);
				return getLyraEndpoint(endpointId.value, currentSection.endpoints);
			})
			const isCarousel = computed((): boolean => {
				return endpointObj.value ? 'templates' in endpointObj.value && endpointObj.value.templates !== '' : false;
			})

			/**
			 * Image
			 */
			const { carouselIndex, datum } = toRefs(props);
			const imageSource = ref('');
			const captionKey = computed(() => {
				return `${endpointId.value}-${datum.value.area}-caption`;
			})

			watchEffect(async () => {
				try {
					if (isCarousel.value) {
						imageSource.value = require(`@/applications/covid-hub/ui/assets/images/${endpointId.value}-${datum.value.area}-${carouselIndex.value}.png`);
					} else {
						imageSource.value = require(`@/applications/covid-hub/ui/assets/images/${endpointId.value}-${datum.value.area}.png`);
					}
				} catch (err) {
					console.warn(err);
				}
			})

			onBeforeMount(async () => {
				try {
					if (isCarousel.value) {
						imageSource.value = require(`@/applications/covid-hub/ui/assets/images/${endpointId.value}-${datum.value.area}-${carouselIndex.value}.png`);
					} else {
						imageSource.value = require(`@/applications/covid-hub/ui/assets/images/${endpointId.value}-${datum.value.area}.png`);
					}
				} catch (err) {
					console.warn(err);
				}
			})

			return { imageSource, captionKey, endpointId }
		}
	})
